/**
 * This is a compiled JS file.
 * Changes here could be overwritten.
 * Contact your Shopify developers if changes need to be made.
 */

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.init()
  }

  init() {
    // console.log("component-cart.js start")

    try{
      const body = JSON.stringify({});

      fetch(`${routes.cart_url}`, {...postConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        // console.log("returned parsed state")
        // console.log(parsedState)

        try {
          this.updateTextItemCountTotal(parsedState.item_count);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateTextItemSubtotal(parsedState.items_subtotal_price / 100);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateTextItemSubtotalSaved(parsedState.items);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateCanCheckout(parsedState.items);
        }catch(e){
          console.error(e)
        }
      })
    }catch(e){
      console.warning(e)
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
      id: 'spend-stretch-section',
      section: document.getElementById('spend-stretch-section')?.dataset.id,
      selector: '#spend-stretch-section'
    }
    ];
  }

  updateQuantity(line, quantity, name) {
    console.log("update quantity called")

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...postConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if(parsedState.item_count <= 0){
          console.log("disabling cart")

          let cartSection = document.querySelector(`.js-cart-mainsection`)
          let emptyCartSection = document.querySelector(`.js-emptycartsection`)

          if(cartSection && emptyCartSection){
            console.log("disabled cart")
            cartSection.classList.toggle("hidden")
            emptyCartSection.classList.toggle("hidden")
          }
        }

        window.gwp.EventBus.emit('AjaxCart:updated', parsedState);

        // Hide shipping bar if cart is empty
        let shippingBar = document.querySelector('.shipping-bar')
        if(shippingBar) shippingBar.classList.toggle('hidden', parsedState.item_count === 0);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (!elementToReplace) {
            return;
          }

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        try {
          this.updateTextItemCountTotal(parsedState.item_count);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateTextItemSubtotal(parsedState.items_subtotal_price / 100);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateTextItemSubtotalSaved(parsedState.items);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateCanCheckout(parsedState.items);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateDiscount(parsedState);
        }catch(e){
          console.error(e)
        }

        try {
          this.updateTotal(parsedState);
        }catch(e){
          console.error(e)
        }

        console.log(parsedState)

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateTextItemCountTotal(item_count) {
    let itemCountElements = document.querySelectorAll(".js-cart-item_count");

    itemCountElements.forEach((itemCountElement) => {
      itemCountElement.innerHTML = item_count
    })
  }

  updateTextItemSubtotal(subtotal_amount) {
    let itemCountElements = document.querySelectorAll(".js-cart-subtotal");
    let subtotal_amount_formatted = subtotal_amount.toLocaleString('en-US', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0})

    itemCountElements.forEach((itemCountElement) => {
      itemCountElement.innerHTML = subtotal_amount_formatted
    })
  }

  updateCanCheckout(cartItems) {
    //console.log("Testing update no only single recycling")
    //console.log(cartItems.length)

    cartItems.forEach((cartItem) => {
      //console.log("cartItem = " + cartItem.id)
      //console.log("cartItem = " + cartItem.name)
      //console.log("cartItem = " + cartItem.handle)

      if(cartItem.handle == "mattress-recycling" && cartItems.length < 2){
        console.log("DISABLING PROCEED TO CHECKOUT")

        let checkoutButton = document.getElementById("checkout")

        if(checkoutButton){
          checkoutButton.disabled = true
          checkoutButton.classList.remove("bg-yellow-400")
        }

        let checkoutLabel = document.getElementById("js-only-recycling-warning")

        if(checkoutLabel){
          checkoutLabel.classList.remove("hidden")
        }
      }else{
        console.log("NOT DISABLING PROCEED TO CHECKOUT")
      }
    })
  }

  updateDiscount(cartItems) {
    
    //itemDiscount.innerHTML = "changed"
  }  

  updateTotal(parsedState) {
    // discount
    let itemDiscounts = document.querySelectorAll(".js-cart-discount-amount");
    
    console.log("TEST TEST TEST")
    console.log(parsedState)
    console.log("TEST TEST TEST")
    
    let discountAmount = parsedState.total_discount 
    discountAmount = discountAmount / 100
    let discountAmountFormatted = discountAmount.toLocaleString('en-US', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0})
    
    itemDiscounts.forEach((itemDiscount) => {
      itemDiscount.innerHTML = "-" + discountAmountFormatted
    })

    //total
    let itemTotals = document.querySelectorAll(".js-cart-total");
    
    let totalAmount = parsedState.total_price

    console.log("total amount =" + totalAmount)
    totalAmount = totalAmount / 100
    let totalAmountFormatted = totalAmount.toLocaleString('en-US', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0})
    
    itemTotals.forEach((itemTotal) => {
      itemTotal.innerHTML = totalAmountFormatted
    })
  }

  updateTextItemSubtotalSaved(cartItems) {
    let itemCountElementsSaved = document.querySelectorAll(".js-cart-subtotal--saved");
    let itemCountElementsCompare = document.querySelectorAll(".js-cart-subtotal--compare");

    let subtotalSaved = 0

    let totalCompare = 0
    let total = 0

    cartItems.forEach((cartItem) => {
      // console.log(cartItem)

      let comparePrice = cartItem.original_line_price
      let price = cartItem.final_line_price

      total += price;

      let comparePriceEle = document.querySelector(
        `.js-cart-hidden_compare-price_${cartItem.id}`
      );

      let finalComparePrice;

      if (!comparePriceEle || !comparePriceEle.textContent.trim()) {
    finalComparePrice = comparePrice;
  } else {
    let parsedPrice = parseInt(comparePriceEle.textContent, 10);

    if (isNaN(parsedPrice) || parsedPrice <= 0) {
      finalComparePrice = comparePrice;
    } else {
      finalComparePrice = parsedPrice * cartItem.quantity;
    }
  }
      totalCompare += finalComparePrice;

      let priceDifference = finalComparePrice - price;

      if(priceDifference > 0){
        subtotalSaved += priceDifference
      }

      // console.log(`"${cartItem.handle}" : compare_price ${comparePrice}`)
      // console.log(`"${cartItem.handle}" : price ${price}`)
      // console.log(`"${cartItem.handle}" : saving ${priceDifference / 100} on `)
    })

    subtotalSaved = subtotalSaved / 100
    let subtotalSavedFormatted = subtotalSaved.toLocaleString('en-US', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0})

    console.log("test465")

    totalCompare = totalCompare / 100
    total = total / 100

    let totalCompareFormatted = totalCompare.toLocaleString('en-US', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0})

    itemCountElementsSaved.forEach((itemCountElement) => {
      itemCountElement.innerHTML = subtotalSavedFormatted

      let itemCountElementWrappers = document.querySelectorAll(".js-cart-subtotal--saved-wrapper")

      if(itemCountElementWrappers){
        itemCountElementWrappers.forEach((itemCountElementWrapper) => {
          if(subtotalSaved == 0){
            if(!itemCountElementWrapper.classList.contains('hidden')){
              itemCountElementWrapper.classList.toggle('hidden')
            }
          }else{
            if(itemCountElementWrapper.classList.contains('hidden')){
              itemCountElementWrapper.classList.toggle('hidden')
            }
          }
        })
      }
    })

    itemCountElementsCompare.forEach((itemCountElement) => {
      itemCountElement.innerHTML = totalCompareFormatted
// Hide elements when 0
if (totalCompare == 0 || totalCompare == total) {
  itemCountElement.classList.add("hidden");
  itemCountElement.classList.remove("invisible");
} else {
  itemCountElement.classList.remove("hidden", "invisible");
}
    
  })

}

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


const updateNibbleButton = (showBar) => {
  return

  let nibbleButton = document.querySelector("#fc_frame")

  if(nibbleButton){
    if(showBar){
      nibbleButton.classList.add("fc_frame-offset--cart")
    }else{
      nibbleButton.classList.remove("fc_frame-offset--cart")
    }
  }else{
    setTimeout(updateNibbleButton(), 3000)
  }
}
// Check for nibble for certain amount of time to offset it when it loads in
let elapsedCheckForNibble = 0
let elapsedCheckForNibbleMax = 10 * 1000
let elapsedCheckForNibbleDelay = 500
const checkForNibble = () => {
  if(elapsedCheckForNibble >= elapsedCheckForNibbleMax) return;
  let nibbleButton = document.querySelector("#fc_frame--cart")
  if (nibbleButton) {
    nibbleButton.classList.add("fc_frame-offset--cart")

    return;
  }

  setTimeout( checkForNibble, elapsedCheckForNibbleDelay );
  elapsedCheckForNibble += elapsedCheckForNibbleDelay;
}

console.log("hupi - start")
window.when('.js-cart-atc-bar', () => {
  checkForNibble()

  const el = document.querySelector('.js-cart-atc-bar');
  const trigger = document.querySelector('.js-cart-atc-bar-trigger');
  if(!el) return;
  const btn = el.querySelector('.js-btn');
  const target = document.querySelector('.js-cart-atc-bar-target');

  btn.addEventListener('click', (e) => {
    target.scrollIntoView({behavior: 'smooth', block: 'center'});
    e.preventDefault();
  });

  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    const observer = new IntersectionObserver((entries) => {
      let rect = entries[0].boundingClientRect
      let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      // const showBar = (entries[0].boundingClientRect.y < 0);
      let showBar = (rect.bottom < 0 || rect.top - viewHeight >= 0);

      el.classList.toggle('is-visible', showBar);

      el.classList.toggle('is-visible', showBar);

      updateNibbleButton(showBar);
    }, {
      threshold: 1.0,
      root: null,
    });

    observer.observe(trigger);
  }
});
